import cs from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import type { FC } from 'react';
import { useCallback } from 'react';
import { useAccordion } from '@/DesignSystem/Hook';
import type { IAccordionProps } from '@/DesignSystem/Model/DataModel';
const Accordion: FC<IAccordionProps> = ({
  children,
  className,
  defaultIsOpen,
  isOpen,
  onToggle,
  header
}) => {
  const {
    onToggle: accordionToggle,
    isOpen: accordionIsOpen
  } = useAccordion({
    defaultIsOpen
  });
  const realIsOpen = isOpen !== undefined ? isOpen : accordionIsOpen;
  const realOnToggle = useCallback(onToggle ?? accordionToggle, [onToggle, accordionToggle]);
  return <div className={cs(className, 'group overflow-hidden ', isOpen && 'ui--is-open')} data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
      <motion.header initial={realIsOpen} onClick={realOnToggle} data-sentry-element="unknown" data-sentry-source-file="Accordion.tsx">
        {header}
      </motion.header>
      <AnimatePresence initial={realIsOpen} data-sentry-element="AnimatePresence" data-sentry-source-file="Accordion.tsx">
        {realIsOpen && <motion.section key="content" initial="collapsed" animate="open" exit="collapsed" variants={{
        open: {
          opacity: 1,
          height: 'auto'
        },
        collapsed: {
          opacity: 0,
          height: 0
        }
      }} transition={{
        duration: 0.8,
        ease: [0.04, 0.62, 0.23, 0.98]
      }}>
            <motion.div variants={{
          collapsed: {
            scale: 0.8
          },
          open: {
            scale: 1
          }
        }} transition={{
          duration: 0.8
        }}>
              {children}
            </motion.div>
          </motion.section>}
      </AnimatePresence>
    </div>;
};
export default Accordion;